/* Italstone porcelain library — effect tabs + In-Stock toggle, client-side over
   server-rendered series cards. Counts update live; empty state; heading swaps. */
(function () {
  'use strict';
  var root = document.querySelector('[data-porc-library]');
  if (!root) return;

  var grid = root.querySelector('[data-porc-grid]');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-series]'));
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-effect-tab]'));
  var toggle = root.querySelector('[data-stock-toggle]');
  var emptyEl = root.querySelector('[data-porc-empty]');
  var headingEl = root.querySelector('[data-porc-heading]');
  var emptyEffectEl = root.querySelector('[data-empty-effect]');

  var state = { effect: 'all', stockedOnly: false };
  var total = cards.length;
  var totalStocked = cards.filter(function (c) { return c.getAttribute('data-stocked') === 'true'; }).length;

  function poolFor(stockedOnly) {
    return stockedOnly ? cards.filter(function (c) { return c.getAttribute('data-stocked') === 'true'; }) : cards;
  }
  function countFor(effect, stockedOnly) {
    var pool = poolFor(stockedOnly);
    if (effect === 'all') return pool.length;
    return pool.filter(function (c) { return c.getAttribute('data-effect') === effect; }).length;
  }

  function visibleCards() {
    return cards.filter(function (c) {
      if (state.stockedOnly && c.getAttribute('data-stocked') !== 'true') return false;
      if (state.effect !== 'all' && c.getAttribute('data-effect') !== state.effect) return false;
      return true;
    });
  }

  function updateHeading(n) {
    if (!headingEl) return;
    var em = '<em style="font-style:italic;font-weight:300;">';
    if (state.stockedOnly) {
      headingEl.innerHTML = n + ' stocked ' + (n === 1 ? 'color' : 'colors') + ', ' + em + 'ready to ship.</em>';
    } else if (n === total) {
      headingEl.innerHTML = total + ' series, ' + em + 'one library.</em>';
    } else {
      headingEl.innerHTML = n + ' ' + (state.effect === 'all' ? '' : state.effect + ' ') + 'series, ' + em + 'one library.</em>';
    }
  }

  function apply() {
    cards.forEach(function (c) { c.style.display = 'none'; });
    var vis = visibleCards();
    vis.forEach(function (c) { c.style.display = ''; });

    // tab counts + disabled state
    tabs.forEach(function (tab) {
      var eff = tab.getAttribute('data-effect-tab');
      var n = countFor(eff, state.stockedOnly);
      var badge = tab.querySelector('[data-tab-count]');
      if (badge) badge.textContent = n;
      tab.disabled = n === 0;
      tab.style.opacity = n === 0 ? '0.35' : '1';
      tab.classList.toggle('is-on', eff === state.effect);
    });

    if (emptyEl) emptyEl.hidden = vis.length !== 0;
    if (emptyEffectEl) emptyEffectEl.textContent = state.effect === 'all' ? '' : state.effect + ' ';
    if (grid) grid.hidden = vis.length === 0;
    updateHeading(vis.length);
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.disabled) return;
      state.effect = tab.getAttribute('data-effect-tab');
      apply();
    });
  });

  if (toggle) {
    var badge = toggle.querySelector('[data-stock-count]');
    if (badge) badge.textContent = totalStocked;
    toggle.addEventListener('click', function () {
      state.stockedOnly = !state.stockedOnly;
      toggle.setAttribute('aria-pressed', String(state.stockedOnly));
      toggle.classList.toggle('is-on', state.stockedOnly);
      apply();
    });
  }

  var clearBtn = root.querySelector('[data-porc-clear]');
  if (clearBtn) clearBtn.addEventListener('click', function () {
    state.stockedOnly = false;
    if (toggle) { toggle.classList.remove('is-on'); toggle.setAttribute('aria-pressed', 'false'); }
    apply();
  });

  apply();
})();
